import { r as registerInstance, h, c as createEvent, g as getElement } from './index-16dc7dde.js';
import { i as isEmpty_1 } from './isEmpty-b60327cb.js';
import { I as ICONS_BY_TYPE, A as ACTION_BLOCK_TYPES } from './all-products-8182e14d.js';
import './request.constants-deb285e0.js';
import { c as classnames } from './index-136476ff.js';
import { o as omit_1 } from './omit-0983201d.js';
import { R as RANGES_PLACEHOLDER } from './label-placeholders-2642411f.js';
import './isTypedArray-dfccd669.js';
import './isObject-33fa1780.js';
import './_commonjsHelpers-ba3f0406.js';
import './toString-da636857.js';
import './isSymbol-45bfef0c.js';
import './_Uint8Array-2e849395.js';
import './identity-6651b537.js';
import './_baseTimes-db8626dd.js';
import './_isIndex-af307327.js';
import './_assignValue-8e900715.js';
import './_getAllKeysIn-8178afb2.js';
import './_flatRest-49cdf089.js';
import './_baseFlatten-2670ede5.js';

const actionBlocksCss = "@media screen and (max-width: 979px){.action-blocks{padding:24px 8px}}.action-blocks__item{display:block}@media screen and (max-width: 979px){.action-blocks__item{margin-bottom:12px}}";

const actionBlocksOrder = [
  ACTION_BLOCK_TYPES.PRODUCTS_FROM_A_TO_Z,
  ACTION_BLOCK_TYPES.PRODUCT_SELECTOR_LIST,
  ACTION_BLOCK_TYPES.MASTER_RANGE_PRODUCT,
  ACTION_BLOCK_TYPES.DOWNLOAD_CENTER,
];
let ActionBlocks = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
  }
  render() {
    const actionBlocks = actionBlocksOrder
      .map((actionBlockName) => { var _a; return (_a = this.actionBlocks) === null || _a === void 0 ? void 0 : _a[actionBlockName]; })
      .filter(Boolean);
    return (h("div", { class: "action-blocks" }, actionBlocks.map((item) => {
      if (!isEmpty_1(item.selectorConfig)) {
        return (h("pes-action-block-product-selector", { key: item.type, "data-autotests-id": item.type, actionBlock: item, selectorConfig: this.selectorConfig, class: "action-blocks__item" }));
      }
      return (h("pes-action-block", { key: item.type, "data-autotests-id": item.type, heading: item.label, text: item.linkText, url: item.link, icon: ICONS_BY_TYPE[item.type], class: "action-blocks__item" }));
    })));
  }
};
ActionBlocks.style = actionBlocksCss;

const ICONS = {
  1: 'segment_industry',
  2: 'segment_building',
  3: 'segment_datacentre',
  4: 'electricity_switch',
  5: 'segment_residential',
  6: 'electricity_protection_MVrelay',
  7: 'weather_sunny',
  12: 'segment_energy_infrastructure',
};

const businessLinesSeCss = ":host{display:block}";

let BusinessLinesSe = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.pesBreadcrumbsTailDidAppend = createEvent(this, "pesBreadcrumbsTailDidAppend", 7);
    this.disableBusinessLinesHashRouting = false;
    this.isPBS = false;
    this.carouselSelectCell = -1;
    this.changeBusinessLineByHash = () => {
      var _a, _b, _c;
      const sourceId = this.getBusinessLineByHash();
      const index = (_a = this.linesList) === null || _a === void 0 ? void 0 : _a.findIndex((line) => (line === null || line === void 0 ? void 0 : line.sourceId) === sourceId);
      this.carouselSelectCell = index;
      this.changeActiveLine && this.changeActiveLine((_c = (_b = this.linesList) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.id);
    };
    this.handlePopState = () => {
      this.changeBusinessLineByHash();
    };
  }
  activeLineChanged(activeLine) {
    if (!this.isPBS && !this.disableBusinessLinesHashRouting) {
      this.pushBusinessLinesState(activeLine);
    }
    this.emitBusinessLineDidChangeEvent(activeLine);
  }
  pushBusinessLinesState(activeLine) {
    const { sourceId } = activeLine !== null && activeLine !== void 0 ? activeLine : {};
    let hash = '#';
    if (sourceId) {
      hash = sourceId.startsWith('/') ? `#${sourceId}` : `#/${sourceId}`;
    }
    window.history.pushState(null, hash, hash);
  }
  emitBusinessLineDidChangeEvent(activeLine) {
    const eventData = [];
    const activeBusinessLine = activeLine;
    if (activeBusinessLine) {
      eventData.push({
        id: activeBusinessLine.sourceId,
        name: activeBusinessLine.name,
        itemType: 'BUSINESS',
        url: null,
      });
    }
    this.pesBreadcrumbsTailDidAppend.emit(eventData);
  }
  initBusinessLinesRouting() {
    this.changeBusinessLineByHash();
    window.addEventListener('popstate', this.handlePopState);
  }
  getBusinessLineByHash() {
    return window.location.hash.replace(/^#?\//, '');
  }
  connectedCallback() {
    if (!this.disableBusinessLinesHashRouting) {
      this.initBusinessLinesRouting();
    }
  }
  disconnectedCallback() {
    window.removeEventListener('popstate', this.handlePopState);
  }
  render() {
    return (h("pes-business-lines-view", { linesList: this.linesList, topTangesLabel: this.topTangesLabel, viewOnLabel: this.viewOnLabel, productsLabel: this.productsLabel, productRelationsViewProdLabel: this.productRelationsViewProdLabel, seeAllOffersLink: this.seeAllOffersLink, mostViewedProductsLabel: this.mostViewedProductsLabel, learnMoreLabel: this.learnMoreLabel, business: this.business, activeLine: this.activeLine, isMobile: this.isMobile, iconNameMap: ICONS, carouselSelectCell: this.carouselSelectCell, onBusinessLineDidClick: ({ detail }) => this.selectBl(detail === null || detail === void 0 ? void 0 : detail.id, detail === null || detail === void 0 ? void 0 : detail.sourceId), isPBS: this.isPBS }));
  }
  static get watchers() { return {
    "activeLine": ["activeLineChanged"]
  }; }
};
BusinessLinesSe.style = businessLinesSeCss;

function isActionBlock(item) {
  return 'label' in item && 'type' in item && 'linkText' in item;
}
function isActionBlockArray(item) {
  return Array.isArray(item) && isActionBlock(item[0]);
}

const MAX_TOP_CATEGORIES = 12;
const ACTION_BLOCK_GROUPS = {
  PRIMARY: [ACTION_BLOCK_TYPES.PRODUCTS_FROM_A_TO_Z, ACTION_BLOCK_TYPES.PRODUCT_SELECTOR_LIST],
  ALT_PRIMARY: [ACTION_BLOCK_TYPES.DOWNLOAD_CENTER],
  SECONDARY: [ACTION_BLOCK_TYPES.MASTER_RANGE_PRODUCT, ACTION_BLOCK_TYPES.DOWNLOAD_CENTER],
  ALT_SECONDARY: [],
};
const gridWithOneActionBlock = {
  6: [0, 1, 2, 3, 4, 5],
  7: [0, 1, 2, 3, 6],
  8: [0, 3, 4, 7],
  9: [0, 5, 8],
  10: [0, 9],
  11: [0],
};
const gridWithTwoActionBlocks = {
  8: [0, 1, 2, 3],
  9: [0, 5, 7],
  10: [0, 8],
  11: [0],
};

const getActionBlocksByKeyList = (keys, actionBlocks) => {
  return keys.map((key) => actionBlocks[key]).filter(Boolean);
};
const getActionBlockCellsCount = (actionBlocks, isAltSecondary = false) => {
  const keys = Object.keys(actionBlocks !== null && actionBlocks !== void 0 ? actionBlocks : {});
  if (!keys.length) {
    return 0;
  }
  const group = isAltSecondary ? ACTION_BLOCK_GROUPS.ALT_SECONDARY : ACTION_BLOCK_GROUPS.SECONDARY;
  return keys.some((key) => group.includes(key)) ? 2 : 1;
};
const getTopCategoriesMaxCount = (actionBlocks) => {
  return MAX_TOP_CATEGORIES - getActionBlockCellsCount(actionBlocks);
};
const getLeftCellIndex = (categoriesTotalCount, actionBlocks, isAltGroups = false) => {
  const actionBlockCellsCount = getActionBlockCellsCount(actionBlocks, isAltGroups);
  const categoriesMaxCount = getTopCategoriesMaxCount(actionBlocks);
  const categoriesCount = Math.min(categoriesTotalCount, categoriesMaxCount);
  const totalCount = categoriesCount + actionBlockCellsCount;
  if (actionBlockCellsCount === 1) {
    return totalCount < 11 ? totalCount - 3 : totalCount - 4;
  }
  if (actionBlockCellsCount === 2) {
    return totalCount === 9 || totalCount === 10 ? totalCount - 3 : totalCount - 4;
  }
};
const getGridItemsComposition = (categories, actionBlocks, isAltGroups = false) => {
  if (!actionBlocks || !Object.keys(actionBlocks).length) {
    return categories.slice(0, MAX_TOP_CATEGORIES);
  }
  const topCategoriesMaxCount = getTopCategoriesMaxCount(actionBlocks);
  const itemsComposition = categories.slice(0, topCategoriesMaxCount);
  const leftCellIndex = getLeftCellIndex(categories.length, actionBlocks, isAltGroups);
  const primaryGroup = getActionBlocksByKeyList(isAltGroups ? ACTION_BLOCK_GROUPS.ALT_PRIMARY : ACTION_BLOCK_GROUPS.PRIMARY, actionBlocks);
  const secondaryGroup = isAltGroups
    ? getActionBlocksByKeyList(ACTION_BLOCK_GROUPS.ALT_SECONDARY, actionBlocks)
    : getActionBlocksByKeyList(ACTION_BLOCK_GROUPS.SECONDARY, actionBlocks);
  itemsComposition.splice(leftCellIndex, 0, primaryGroup);
  if (secondaryGroup.length) {
    itemsComposition.push(secondaryGroup);
  }
  return itemsComposition;
};
const isTopCategoryCardLarge = (topCategoriesCount, actionBlocks, itemIndex, isAltSecondary = false) => {
  var _a;
  const actionBlockCellsCount = getActionBlockCellsCount(actionBlocks, isAltSecondary);
  const totalCount = topCategoriesCount + actionBlockCellsCount;
  const grid = actionBlockCellsCount === 2 ? gridWithTwoActionBlocks : gridWithOneActionBlock;
  return (_a = grid[totalCount]) === null || _a === void 0 ? void 0 : _a.includes(itemIndex);
};

const topCategoriesCss = ".top-categories{background-color:#f7f7f7;box-sizing:border-box}.top-categories *,.top-categories *::before,.top-categories *::after{box-sizing:inherit}@media screen and (max-width: 979px){.top-categories{margin:0 auto;padding:0 0 24px;min-height:208px}}@media screen and (min-width: 980px){.top-categories{margin:0;margin-top:4px;padding:0;display:flex;flex-wrap:wrap;width:100%}}.top-categories__slider{width:100%}@media screen and (max-width: 979px){:host(:not([dir=\"rtl\"])) .top-categories__slider{padding:0 0 20px 12px}:host([dir=\"rtl\"]) .top-categories__slider{padding:0 12px 20px 0}}.top-categories__action-block{display:block;height:calc(50% - 10px)}.top-categories__action-block+.top-categories__action-block{margin-top:20px}.top-categories__action-block:only-child{height:100%}@media screen and (min-width: 980px){.top-categories__card{width:25%;max-width:300px;height:300px;padding:10px}}@media screen and (min-width: 980px){.top-categories__card--large{width:50%;max-width:600px}}";

const CARD_OFFSET_WIDTH = 168;
let TopCategories = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.list = [];
    this.cardCountPlaceholder = RANGES_PLACEHOLDER;
    this.isActive = false;
    this.hideDownloadCenterBanner = false;
    this.hideMasterRangesBanner = false;
    this.selectorConfig = null;
    this.isPBS = false;
    this.filteredActionBlocks = {};
    this.createSliderRef = (el) => {
      this.sliderRef = el;
    };
    this.resizeWindow = () => {
      this.cardsPerSlide = this.calcItemsPerSlide();
    };
    this.renderActionBlock = (item) => {
      if (!isEmpty_1(item.selectorConfig)) {
        return (h("pes-action-block-product-selector", { "data-autotests-id": item.type, actionBlock: item, selectorConfig: this.selectorConfig, class: "top-categories__action-block" }));
      }
      return (h("pes-action-block", { "data-autotests-id": item.type, heading: item.label, text: item.linkText, url: item.link, icon: ICONS_BY_TYPE[item.type], class: "top-categories__action-block" }));
    };
    this.el.dir = document.documentElement.dir || 'auto';
  }
  actionBlocksWatcher() {
    this.updateFilteredActionBlocksState();
  }
  componentWillLoad() {
    this.updateFilteredActionBlocksState();
    window.addEventListener('resize', this.resizeWindow);
  }
  componentDidLoad() {
    this.cardsPerSlide = this.calcItemsPerSlide();
  }
  disconnectedCallback() {
    window.removeEventListener('resize', this.resizeWindow);
  }
  updateFilteredActionBlocksState() {
    const actionBlocksToOmit = [
      this.hideDownloadCenterBanner && ACTION_BLOCK_TYPES.DOWNLOAD_CENTER,
      this.hideMasterRangesBanner && ACTION_BLOCK_TYPES.MASTER_RANGE_PRODUCT,
    ].filter(Boolean);
    this.filteredActionBlocks = omit_1(this.actionBlocks, actionBlocksToOmit);
  }
  calcItemsPerSlide() {
    if (this.sliderRef) {
      return this.sliderRef.offsetWidth / CARD_OFFSET_WIDTH;
    }
  }
  renderCard(category, isCardLarge = false) {
    const key = `${category.id}${this.isActive ? '_active' : ''}`;
    return (h("pes-card", { key: key, page: "category", item: category, viewOnLabel: this.viewOnLabel, labelTemplate: this.cardCountLabel, labelPlaceholder: this.cardCountPlaceholder, size: isCardLarge && 'large' }));
  }
  renderList() {
    const grid = getGridItemsComposition(this.list, this.filteredActionBlocks, this.isPBS);
    return grid === null || grid === void 0 ? void 0 : grid.map((item, index) => {
      if (isActionBlockArray(item)) {
        return h("div", { class: "top-categories__card" }, item === null || item === void 0 ? void 0 : item.map(this.renderActionBlock));
      }
      const isCardLarge = isTopCategoryCardLarge(this.list.length, this.filteredActionBlocks, index, this.isPBS);
      return (h("div", { class: classnames('top-categories__card', { 'top-categories__card--large': isCardLarge }) }, this.renderCard(item, isCardLarge)));
    });
  }
  render() {
    var _a;
    if (this.isMobile) {
      return (h("section", { class: "top-categories" }, h("div", { class: "top-categories__slider" }, h("pdp-slider", { ref: this.createSliderRef, class: "media-gallery-mobile", childrenClassName: ".mobile-gallery-slide", itemsPerSlide: this.cardsPerSlide, showPointers: true, showButtons: false, smallPoint: true }, (_a = this.list) === null || _a === void 0 ? void 0 : _a.map((category) => this.renderCard(category))))));
    }
    return h("section", { class: "top-categories" }, this.renderList());
  }
  get el() { return getElement(this); }
  static get watchers() { return {
    "actionBlocks": ["actionBlocksWatcher"],
    "hideDownloadCenterBanner": ["actionBlocksWatcher"],
    "hideMasterRangesBanner": ["actionBlocksWatcher"]
  }; }
};
TopCategories.style = topCategoriesCss;

export { ActionBlocks as pes_action_blocks, BusinessLinesSe as pes_business_lines_se, TopCategories as pes_top_categories };
